import {Button, Select, Typography} from "antd";
import {useEffect, useState} from "react";
import ApiService from "../../core/service/api-service";
import {t} from "i18next";

export default function StudyExportModal({studyIdList, onExport}) {
    const [exports, setExports] = useState([])
    const [exportName, setExportName] = useState(null)

    const get = async () => {
        const res = await ApiService.Dicom.GetExportAETitleList(studyIdList)
        if(res.success) {
            const _data = res.data.map(x => {
                if(x.includes('@')) {
                    const vals = x.split('@')
                    return {
                        name: vals[0],
                        aet: vals[1]
                    }
                }

                return {
                    name: x,
                    aet: x
                }
            })
            setExports(_data)
            setExportName(_data[0])
        }
    }

    useEffect(() => {
        get()
    }, [])

    return (
        <>
            <div style={{display: 'flex', alignItems: 'center', gap: 8, marginBottom: 8}}>
                <Typography.Text>
                    {t('Export Name')} ({studyIdList?.length} {t('Study')})
                </Typography.Text>
                <Select
                    style={{width: 200}}
                    onChange={(e) => setExportName(e)}
                    value={exportName}
                >
                    {
                        exports.map(x => (
                            <Select.Option value={x?.aet} key={x?.aet}>
                                {x?.name}
                            </Select.Option>
                        ))
                    }
                </Select>
            </div>
            <Button
                size={'small'}
                type={'primary'}
                style={{marginTop: 8}}
                onClick={() => {
                    onExport && onExport(exportName, studyIdList)
                }}
            >
                {t('Export Study')}
            </Button>
        </>
    )
}